import {
  FETCH_PRIZE,
  FETCH_PRIZE_SUCCEED,
  FETCH_PRIZE_FAILED,

  CREATE_PRIZE,
  CREATE_PRIZE_SUCCEED,
  CREATE_PRIZE_FAILED,

  UPDATE_PRIZE,
  UPDATE_PRIZE_SUCCEED,
  UPDATE_PRIZE_FAILED,

  FETCH_LUCKY_GAME_CONFIG,
  FETCH_LUCKY_GAME_CONFIG_SUCCEED,
  FETCH_LUCKY_GAME_CONFIG_FAILED,
} from './action_types';

export default {
  fetchPrize: () => ({
    type: FETCH_PRIZE,
  }),
  fetchPrizeSucceed: (data) => ({
    type: FETCH_PRIZE_SUCCEED,
    data,
  }),
  fetchPrizeFailed: (err) => ({
    type: FETCH_PRIZE_FAILED,
    err,
  }),
  createPrize: (data) => ({
    type: CREATE_PRIZE,
    data,
  }),
  createPrizeSucceed: (data) => ({
    type: CREATE_PRIZE_SUCCEED,
    data,
  }),
  createPrizeFailed: (err) => ({
    type: CREATE_PRIZE_FAILED,
    err,
  }),
  updatePrize: (data) => ({
    type: UPDATE_PRIZE,
    data,
  }),
  updatePrizeSucceed: (data) => ({
    type: UPDATE_PRIZE_SUCCEED,
    data,
  }),
  updatePrizeFailed: (err) => ({
    type: UPDATE_PRIZE_FAILED,
    err,
  }),
  fetchLuckyGameConfig: () => ({
    type: FETCH_LUCKY_GAME_CONFIG,
  }),
  fetchLuckyGameConfigSucceed: (data) => ({
    type: FETCH_LUCKY_GAME_CONFIG_SUCCEED,
    data,
  }),
  fetchLuckyGameConfigFailed: (err) => ({
    type: FETCH_LUCKY_GAME_CONFIG_FAILED,
    err,
  }),
};
